export default __webpack_public_path__ + "static/media/library-2.a888684a.jpg";